/**
 * created by yxxyyxyx
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Col, DatePicker, Input, message, Upload} from 'antd';
import BaseComponent from "../../../../base/BaseComponent";
import request from "../../../../base/request";
import moment from 'moment';
import Btn from "../../components/btn/Btn";
import InputNumber from  '../../components/InputNumber'

const {MonthPicker, RangePicker} = DatePicker;
const {TextArea} = Input;
export default class AddSolicitation extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            arrangementCon:{},
            Solicitation: {
                time: '',
                requirement: '',
            }

        }
    }

    componentWillMount() {


    }

    sysConfigLoadOver() {
        let record = this.props.record;
        let operation = this.sysConfig.operation || 'add';
        if (record && operation =="add") {
            this.initArrangementCon()
            // this.setState({arrangementCon:{}})
        }else {
            let array = [];
            let newArray = []
            if(record.receiverObjs){
                record.receiverObjs.forEach((item)=>{
                    array.push(item.receiver.name);
                    newArray.push(item)
                });
            }
            this.state.arrangementCon = record;
            this.state.arrangementCon.contacts =array;
            this.state.arrangementCon.correspondent=newArray;
            this.setState({},()=>{
                console.log(this.state.arrangementCon.correspondent)
        })
        }
    }
    componentDidMount() {
    }

    editClue() {
        // let
    }

    initArrangementCon() {
        this.state.arrangementCon.title = '';
        this.state.arrangementCon.contacts = '';
        this.state.arrangementCon.content = '';
        this.state.arrangementCon.contactsWay = '';
        this.state.arrangementCon.resourceVideos = '';
        this.state.arrangementCon.resourcePictures = '';
        this.state.arrangementCon.attachments = '';
    }

    render() {
        let {
            operation = 'add',
            FeedbackTimeKey = "回稿时间",
            FeedbackTimeShow = true,
            FeedbackTimeRequired = true,
            FeedbackTimeParam = 'replyDate',
            FeedbackTimePlaceholder = '请选择回稿时间',
            FeedbackTimeDisabled = false,


            requirementShow = true,
            requirementKey = '稿件要求',
            requirementRequired = true,
            requirementParam = 'requireContent',
            requirementPlaceholder = '请输入回稿要求',
            requirementDisabled = false,
            requirementMaxlength= 500,


            objectShow = true,
            objectKey = '约稿对象',
            objectRequired = true,
            objectParam = 'receivers',
            objectPlaceholder = '请选择约稿对象',
            objectDisabled = false,
            objectFocus = [],

            mediaShow = true,
            mediaKey = '发布媒体',
            mediaRequired = true,
            mediaParam = 'mediaCodes',
            mediaPlaceholder = '请选择发布媒体',
            mediaDisabled = true,
        } = this.sysConfig;
        let {arrangementCon} = this.state;
       let SolicitationBtn=this.sysConfig.SolicitationBtn||null;
       let mediaBtn = this.sysConfig.mediaBtn||null;
        return (
            <div>
                {FeedbackTimeShow && <div style={{display: 'flex', marginTop: '20px'}}>
                    <div style={{width: '93px', display: 'flex', alignItems: 'center'}}>{FeedbackTimeRequired ?
                        <span style={{color: 'red', marginRight: '5px'}}>*</span> : null}{FeedbackTimeKey}:
                    </div>
                    <div style={{width:'200px'}}>
                         <DatePicker
                                style={{width: '100%'}}
                                disabled={FeedbackTimeDisabled}
                                format="YYYY-MM-DD HH:mm:ss"
                                placeholder={FeedbackTimePlaceholder}
                                disabledDate={this.disabledDate}
                                // defaultValue={arrangementCon && arrangementCon[FeedbackTimeParam]?moment(arrangementCon[FeedbackTimeParam]):null }
                                value={arrangementCon && arrangementCon[FeedbackTimeParam] ?moment( arrangementCon && arrangementCon[FeedbackTimeParam]):null}
                                onChange={(value) => {
                                    console.log(value.format('YYYY-MM-DD HH:mm:ss'))
                                    this.state.arrangementCon.replyDate = value ? value.format('YYYY-MM-DD HH:mm:ss') : "";
                                    this.setState({})
                                }}
                                showTime={{defaultValue: moment('00:00:00', 'HH:mm:ss')}}
                            />
                    </div>
                </div>}
                {requirementShow && <div style={{display: 'flex', marginTop: '15px'}}>
                    <div style={{width: '100px', display: 'flex', alignItems: 'center'}}>{requirementRequired ?
                        <span style={{color: 'red', marginRight: '5px'}}>*</span> : null}{requirementKey}:
                    </div>
                    <div style={{width: '100%'}}>
                        <InputNumber  value={arrangementCon && arrangementCon.requireContent}
                                      disabled={requirementDisabled}
                                      placeholder={requirementPlaceholder}
                                      maxlength={requirementMaxlength}
                                      onChange={(e) => {
                                          if(requirementMaxlength){
                                              if(e.target.value.length>=requirementMaxlength){
                                                  e.target.value.length =requirementMaxlength
                                              }
                                          }
                                          this.onChange('requireContent', e.target.value)
                                      }}>

                        </InputNumber>

                    </div>
                </div>}
                <div style={{display:'flex'}}>
                    {objectShow && <div style={{display: 'flex', marginTop: '15px',alignItems:'center'}}>
                        <div style={{width: '93px'}}>{objectRequired ?
                            <span style={{color: 'red', marginRight: '5px'}}>*</span> : null}{objectKey}:
                        </div>
                        <div >
                            {operation === 'details' ? <div style={{width: '100%'}}> {arrangementCon && arrangementCon[objectParam]}</div> :
                                <Input  disabled={objectDisabled} placeholder={mediaParam}
                                        placeholder={objectPlaceholder}
                                        value={arrangementCon && arrangementCon.contacts}
                                        style={{width: '200px'}}
                                        onChange={(e) => {
                                            this.onChange('contacts', e.target.value)
                                        }}/>}
                        </div>
                        <div style={{width: '8%',marginLeft:'10px'}}> <Btn btnList={SolicitationBtn} currentState={this.state} record={this.state.arrangementCon.correspondent}
                                                                         refresh={(data) => this.refresh(data)}/></div>

                    </div>}
                    {mediaShow && <div style={{display: 'flex', marginTop: '15px',marginLeft:'60px',alignItems:'center'}}>
                        <div style={{width: '80px'}}>{mediaRequired ?
                            <span style={{color: 'red', marginRight: '5px'}}>*</span> : null}{mediaKey}:
                        </div>
                        <div >
                            {operation === 'details' ? <div style={{width: '100%'}}> {arrangementCon && arrangementCon[mediaParam]}</div> :
                                <Input disabled={mediaDisabled} placeholder={objectParam}
                                       placeholder={mediaPlaceholder}
                                       style={{width: '200px'}}
                                       value={arrangementCon && arrangementCon.contactsWay}
                                       onChange={(e) => {
                                           this.onChange('contactsWay', e.target.value)
                                       }}/>}
                        </div>
                        <div style={{width: '8%',marginLeft:'10px'}}> <Btn btnList={mediaBtn} currentState={this.state} record={this.state.record}
                                                                         refresh={() => this.refresh()}/></div>
                    </div>}
                </div>

            </div>
        )
    }

    onChange = (key, value) => {
        this.state.arrangementCon[key] = value;
        this.setState({}, () => {
        })
    };

    disabledDate = (current) => {

        // Can not select days before today and today
        return current && current < moment().subtract(1, "days");
    };
    refresh(data) {
        console.log(data,'data')

        let array =[];


            data&&data.forEach((item,index)=>{
                if(item.receiver){
                    array.push(item.receiver.name)
                }else{
                    array.push(item.name)
                }

            });
        this.state.arrangementCon.contacts=array;
        this.state.arrangementCon.correspondent= data;

        this.setState({})
    }


    onOk = () => {

        let affirmBtn = this.sysConfig.affirmBtn || {};
        this.save(affirmBtn)

    };
    temp = () => {
        let tempBtn = this.sysConfig.tempBtn || {};
        this.save(tempBtn)
    }

    save(btn) {
        let {
            requirementParam,
            FeedbackTimeParam,
            objectParam,
        } = this.sysConfig;
        let sysConfig = this.sysConfig;
        let url = btn.requestUrl || '';
        let contentKey = btn.contentKey ||"";
        let dateKey = btn.dateKey ||"";
        let mediaCodeKey = btn.mediaCodeKey ||"";
        let receiverIdKey = btn.receiverIdKey ||"";
        let mediaCodeNameKey =btn.mediaCodeNameKey || "";
        let MediaPeople =btn.MediaPeople || "";
        let receiverIds = []
        let receiver ={};
        let depts=[];
        let contentType = btn.contentType || "json";
        let body = {};
        let method = btn.requestMethod || 'post';
        if (url) {

            //校验
            if (FeedbackTimeParam && sysConfig['FeedbackTimeShow']) {
                if (!this.state.arrangementCon.replyDate && sysConfig['FeedbackTimeRequired']) return message.warning( sysConfig['FeedbackTimePlaceholder']||"请选择回稿时间");
                //回稿时间
                body[dateKey] = this.state.arrangementCon.replyDate ?moment(this.state.arrangementCon.replyDate).valueOf():"" ;
            }
            if(requirementParam &&sysConfig['requirementShow']) {
                if(!this.state.arrangementCon.requireContent &&sysConfig['requirementRequired']) return message.warning(sysConfig['requirementPlaceholder']||'请输入回稿要求')
                //回稿要求
                body[contentKey] = this.state.arrangementCon.requireContent ||'';
            }
            if(objectParam&& sysConfig['objectShow']) {
                if (!this.state.arrangementCon.contacts && sysConfig['objectRequired']) return message.warning( sysConfig['objectRequiredPlaceholder']||"请选择回稿时间");
                let statusParam = btn.statusParam;
                let statusKey = btn.statusKey;
                body[statusParam] = statusKey;
                this.state.arrangementCon.correspondent.forEach((item,index)=>{
                   if(item.reporterId){
                       receiverIds.push({
                           receiver:item.receiver,
                           reporterId:item.reporterId
                       })
                    }else{
                        receiver={
                            name:item.name,
                            account:item.account,
                        };
                        if(item.deptList){
                            item.deptList.length&&item.deptList.forEach((items,index)=>{
                                depts.push({
                                    id:items.id,
                                    name:items.name,

                                });
                                receiver.depts = depts
                            })
                        }
                        receiverIds.push({
                            receiver:receiver,
                            reporterId:item.id
                        })
                    }

                });
                body[objectParam] =receiverIds
            }

           // if(mediaParam && sysConfig['mediaShow']) {
           //     body[mediaCodeKey] =  [
           //         "weibo01",
           //         "qtmt"
           //     ]
           //     body[mediaCodeNameKey] =[
           //         "测试媒体2号",
           //         "测试媒体3号"
           //     ]
           // }
            request({
                url: url, contentType: contentType, body, method, callBack: (data) => {
                    // console.log(data)
                    this.complete();
                }
            });

        } else {
            this.complete();
        }
    }

}
